export default function SeoMeta() {
  const siteUrl = "https://muensterland-industrieservice.com";
  const pagePath = "/GartenpflegePage";
  const fullUrl = `${siteUrl}${pagePath}`;
  const title = "Gartenpflege Havixbeck & Münsterland | Münsterland Industrieservice UG";
  const description = "Professionelle Gartenpflege in Havixbeck & Münsterland. Rasenschnitt, Heckenschnitt, Strauchschnitt & Laubbeseitigung - umweltfreundlich und zuverlässig.";
  const imageUrl = `${siteUrl}/img/gartenpflege_muensterland_hero.webp`;
  const imageAlt = "Gartenpflege und Steinflächen im Münsterland";
  return <section id="seometa" className="sr-only" aria-hidden="true">
      {}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullUrl} />

      {}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:site_name" content="Münsterland Industrieservice UG" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={imageAlt} />

      {}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={imageAlt} />
    </section>;
}